<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-page-header @back="goBack" :content="id ? '编辑模板数据' : '添加模板数据'"></el-page-header>
        <el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
            <el-form-item label="行业名称" prop="industry_id">
                <el-select v-model="item.industry_id" @change="industryChange" clearable placeholder="请选择行业名称"
                           size="small">
                    <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="模板名称" prop="industry_template_id">
                <el-select v-model="item.industry_template_id" clearable placeholder="请选择模板名称" size="small">
                    <el-option v-for="item in optionsTemplate" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="是否必填" prop="is_required">
                <el-switch :active-value="1" :inactive-value="0" v-model="item.is_required" active-color="#13ce66"
                           inactive-color="#ccc">
                </el-switch>
            </el-form-item>

            <el-form-item label="参数名称" prop="item_key">
                <el-input v-model="item.item_key" placeholder="请输入参数名称" style="width: 220px"></el-input>
            </el-form-item>

            <el-form-item label="排序号" prop="">
                <el-input v-model="item.sort_order" placeholder="数字越大越靠前" style="width: 220px"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
            </el-form-item>
            <el-form-item>
                <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
                    <span>您确认保存嘛</span>
                    <span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
                </el-dialog>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                item: {
                    is_required: false
                },
                isLoad: false,
                id: this.$route.query.id,
                dialogVisible: false,
                options: [],
                optionsTemplate: [],
                data_typeTemplate: [{
                    id: 1,
                    name: '文本'
                },
                    {
                        id: 6,
                        name: '整数'
                    },
                    {
                        id: 2,
                        name: '日期'
                    },
                    {
                        id: 3,
                        name: '时间'
                    },
                    {
                        id: 4,
                        name: '图片'
                    },
                    {
                        id: 5,
                        name: '附件'
                    },
                ],
                rules: {
                    industry_id: [{
                        required: true,
                        message: '行业名称未选择',
                        trigger: 'blur'
                    },],
                    industry_template_id: [{
                        required: true,
                        message: '模板名称未选择',
                        trigger: 'blur'
                    },],
                    item_key: [{
                        required: true,
                        message: '参数名称不存在',
                        trigger: 'blur'
                    },],
                    data_type: [{
                        required: true,
                        message: '数据类型未选择',
                        trigger: 'blur'
                    },],
                    sort_order: [{
                        required: true,
                        message: '排序号不存在',
                        trigger: 'blur'
                    },],
                }
            }
        },
        created() {
            this.loadData()
        },
        methods: {
            async loadData() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                let res = ""

                res = await this.axios.post('/admin/data/listIndustryForSelect', {})
                this.options = res.data.list
                if (this.id) {
                    res = await this.axios.post('/admin/industry.templateItem/detail', {
                        id: this.id
                    })

                    if (res && res != "undefined") {
                        this.item = res.data.detail
                        this.item.industry_id = this.item.industry_id ? this.item.industry_id : ''
                        var industry_template_id = this.item.industry_template_id ? this.item.industry_template_id : '';

                        if (this.item.industry_id) {
                            this.industryChange()
                        }
                        this.$set(this.item, 'industry_template_id', industry_template_id)
                    }
                    this.$forceUpdate()
                }
                this.isLoad = !this.isLoad
            },
            industryChange() {
                this.optionsTemplate = []
                this.$set(this.item, 'industry_template_id', '')
                var industry_id = this.item.industry_id
                var find = this.options.find(function (item) {
                    return industry_id == item.id
                })
                if (find) {
                    this.optionsTemplate = find.templates
                }
            },
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
            checkSubmit() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.dialogVisible = true
                    } else {
                        this.$message.warning("请检查表单信息是否正确");
                        return false;
                    }
                });
            },
            // 提交
            submit() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.dialogVisible = false
                this.item.sort_order = Number(this.item.sort_order)
                this.item.data_type = 1
                let url = ''
                if (this.id) {
                    url = '/admin/industry.templateItem/update'
                    this.item.id = this.id
                } else {

                    url = '/admin/industry.templateItem/add'
                }
                this.axios.post(url, this.item)
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '保存成功'
                        });
                        this.goBack()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            }
        }
    }
</script>
<style scoped>
</style>·
